import { api } from "./configs/axiosConfig";
import { defineCancelApiObject } from "./configs/axiosUtils";

export const reportApi = {
  getHousePending: async function (
    trackingSysId,
    pageNum,
    quantityItemsPerPage,
    cancel = false
  ) {
    const response = await api.request({
      url: `/HouseExibicao/pendingforms?trackingSysId=${trackingSysId}&pageNum=${pageNum}&quantity=${quantityItemsPerPage}`,
      method: "GET",
      signal: cancel
        ? cancelApiObject[this.get.name].handleRequestCancellation().signal
        : undefined,
    });

    return response.data;
  },
};

const cancelApiObject = defineCancelApiObject(reportApi);
